import CourseList from './CourseList.gql';
import CourseListView from './CourseList.view';

export { CourseList, CourseListView };
export default CourseList;
